import { render } from "./ms-excel-icon.svg?vue&type=template&id=302932af"
import script from "./ms-excel-icon.svg?vue&type=script&lang=js"
export * from "./ms-excel-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src844/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__